import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  // status → [text color, bg]
  Active: ["text-success", "bg-success-bg"],
  Draft: ["text-info", "bg-info-bg"],
  Stayed: ["text-info", "bg-info-bg"],
  Disposed: ["text-ink-2", "bg-secondary"],
  Closed: ["text-ink-2", "bg-secondary"],
  Archived: ["text-ink-muted", "bg-secondary"],
  Urgent: ["text-danger", "bg-danger-bg"],
  High: ["text-danger", "bg-danger-bg"],
  Medium: ["text-warning", "bg-warning-bg"],
  Low: ["text-ink-2", "bg-secondary"],
  Pending: ["text-warning", "bg-warning-bg"],
  Filed: ["text-success", "bg-success-bg"],
  "Awaiting Client": ["text-warning", "bg-warning-bg"],
  "Awaiting Response": ["text-warning", "bg-warning-bg"],
  "Awaiting Approval": ["text-warning", "bg-warning-bg"],
  "Under Review": ["text-info", "bg-info-bg"],
  "Changes Requested": ["text-warning", "bg-warning-bg"],
  Approved: ["text-success", "bg-success-bg"],
  Superseded: ["text-ink-muted", "bg-secondary"],
  "Hearing Soon": ["text-warning", "bg-warning-bg"],
  Overdue: ["text-danger", "bg-danger-bg"],
  Paid: ["text-success", "bg-success-bg"],
  "Part Paid": ["text-warning", "bg-warning-bg"],
  Due: ["text-info", "bg-info-bg"],
  Agreed: ["text-info", "bg-info-bg"],
  Waived: ["text-ink-muted", "bg-secondary"],
  Signed: ["text-success", "bg-success-bg"],
  Completed: ["text-success", "bg-success-bg"],
  "In Progress": ["text-info", "bg-info-bg"],
  "To Do": ["text-ink-2", "bg-secondary"],
  Review: ["text-warning", "bg-warning-bg"],
  Cancelled: ["text-ink-muted", "bg-secondary"],
  Success: ["text-success", "bg-success-bg"],
  Quarantined: ["text-danger", "bg-danger-bg"],
  Queued: ["text-ink-2", "bg-secondary"],
  Rejected: ["text-ink-muted", "bg-secondary"],
  Running: ["text-info", "bg-info-bg"],
  Failed: ["text-danger", "bg-danger-bg"],
  Skipped: ["text-ink-muted", "bg-secondary"],
  Ready: ["text-success", "bg-success-bg"],
  Processing: ["text-info", "bg-info-bg"],
  Uploaded: ["text-success", "bg-success-bg"],
  Paused: ["text-ink-2", "bg-secondary"],
  Connected: ["text-success", "bg-success-bg"],
  "Not Connected": ["text-ink-2", "bg-secondary"],
  "Verified Authority": ["text-success", "bg-success-bg"],
  "Needs Verification": ["text-warning", "bg-warning-bg"],
  "Internal Analysis": ["text-info", "bg-info-bg"],
  Dormant: ["text-ink-2", "bg-secondary"],
};

export function StatusBadge({ status, className }) {
  const [text, bg] = MAP[status] || ["text-ink-2", "bg-secondary"];
  return (
    <span
      data-testid={`status-badge-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
        text, bg, className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", text.replace("text-", "bg-"))} />
      {status}
    </span>
  );
}
